<template>
  <div
    v-if="!loading"
  >
    <div class="row">
      <div class="col-lg-12 col-xs-12">
        <span>Qual vaga será avaliada?</span>
        <VueSuggestion
          :selectedEl="job"
          searchURL="/recruiters/jobs_search"
          responseDataName="jobs"
          :clearOption="true"
          :whenSelected="JobSelected"
        />
      </div>
    </div>
    <div
      v-if="job && job.id"
      class="row mt-3"
    >
      <div class="col-lg-12 col-xs-12">
        <span>Qual processo será avaliado?</span>
        <VueSuggestion
          :selectedEl="selective_process"
          :searchURL="`/recruiters/jobs/${job.id}/kanban.json`"
          responseDataName="selective_processes"
          :clearOption="true"
          :whenSelected="SelectiveProcessSelected"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueSuggestion from "../../../components/VueSuggestion.vue";

export default {
  components: {
    VueSuggestion,
  },
  props: {
    recruiter: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      job: null,
      selective_process: null,
    }
  },

  mounted() {
    if (this.recruiter?.schema_params) {
      this.loading = true;
      this.getJob();
    }
    eventBus.$on(`clearInput-jobs`, () => {
      this.loading = true;
      this.job = null;
       const schema_params = {
        job_id: null,
        selective_process_id: null,
      };
      this.$emit("setSchema", schema_params);
      setTimeout(() => {
        this.loading = false;
      }, 20);
    });
    eventBus.$on(`clearInput-selective_processes`, () => {
      const schema_params = {
        job_id: this.job.id,
        selective_process_id: null,
      };
      this.$emit("setSchema", schema_params);
    });
  },

  methods: {
    JobSelected(item) {
      this.job = item;
      this.loading = true;
      this.selective_process = null;
      setTimeout(() => {
        this.loading = false;
      }, 20);
    },
    SelectiveProcessSelected(item) {
      this.selective_process = item;
      const schema_params = {
        job_id: this.job.id,
        selective_process_id: this.selective_process.id,
      };
      this.$emit("setSchema", schema_params);
    },
    getJob() {
      axios.get(
        `/recruiters/jobs/${this.recruiter.schema_params.job_id}/show`
      )
      .then((response) => {
        this.job = response.data.job;
        if (this.recruiter.schema_params.selective_process_id) {
          this.getSelectiveProcess();
        } else {
          this.loading = false;
        }
      })
    },
    getSelectiveProcess() {
      axios.get(
        `/recruiters/jobs/${this.job.id}/kanban/`
      )
      .then((response) => {
        this.selective_process = response.data.selective_processes.find(
          (selective_process) => selective_process.id === this.recruiter.schema_params.selective_process_id
        );
        this.loading = false;
      })
    }
  },
}
</script>